import { Node } from "@xyflow/react";
import {
  BadgeDimensions,
  BadgePosition,
  checkBadgeOverlapsWithNodes,
  checkBadgeOverlapsWithOtherBadges,
} from "./badge-collision";
import { samplePathPoints } from "./sample-path-points";

const CANDIDATE_POSITIONS = [0.5, 0.4, 0.6, 0.3, 0.7, 0.2, 0.8];

export function findBestBadgePosition(
  svgPath: string,
  nodes: Node[],
  existingBadgePositions: BadgePosition[],
  dimensions: BadgeDimensions,
): BadgePosition {
  const candidatePoints = samplePathPoints(svgPath, CANDIDATE_POSITIONS);

  for (const candidatePosition of candidatePoints) {
    const overlapsWithNodes = checkBadgeOverlapsWithNodes(
      candidatePosition,
      nodes,
      dimensions,
    );
    const overlapsWithBadges = checkBadgeOverlapsWithOtherBadges(
      candidatePosition,
      existingBadgePositions,
      dimensions,
    );

    if (!overlapsWithNodes && !overlapsWithBadges) {
      return candidatePosition;
    }
  }

  // If all positions overlap, return the midpoint (0.5 position)
  const fallbackPoints = samplePathPoints(svgPath, [0.5]);
  return fallbackPoints[0] || { x: 0, y: 0 };
}
